import React from 'react';
import { useLanguage } from '@/services/languageService';
import MainLayout from '@/layouts/MainLayout';
import WhichPokemonBanner from '@/components/WhichPokemonBanner';

const AboutUs = () => {
  const { t } = useLanguage();

  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-center text-purple-700">{t('aboutUsTitle')}</h1>
        
        <div className="prose lg:prose-lg mx-auto">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('aboutUsWhoWeAre')}</h2>
            <p className="mb-4">{t('aboutUsWhoWeAreContent1')}</p>
            <p>{t('aboutUsWhoWeAreContent2')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('aboutUsOurMission')}</h2>
            <p className="mb-4">{t('aboutUsOurMissionContent1')}</p>
            <p>{t('aboutUsOurMissionContent2')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('aboutUsOurTeam')}</h2>
            <p className="mb-4">{t('aboutUsOurTeamContent1')}</p>
            <p>{t('aboutUsOurTeamContent2')}</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('aboutUsJoinUs')}</h2>
            <p>{t('aboutUsJoinUsContent')}</p>
          </section>

          {/* 添加WhichPokemonBanner组件，使用不同的渐变色 */}
          <div className="my-12 -mx-6 sm:-mx-8 lg:-mx-12">
            <WhichPokemonBanner 
              bgGradient="from-purple-500 via-purple-700 to-purple-900" 
            />
          </div>

          {/* Contact Information */}
          <section className="mt-12 p-6 bg-purple-50 rounded-lg">
            <h2 className="text-xl font-semibold mb-3 text-purple-700">{t('contactUs')}</h2>
            <p className="mb-2">
              {t('contactUsEmail')}: contact@randompokemon.games
            </p>
            <p className="text-sm text-gray-600 mt-2">
              {t('aboutUsJoinUsContent')}
            </p>
          </section>
        </div>
      </div>
    </MainLayout>
  );
};

export default AboutUs;
